var exports = {
  "kL": "x43aef4ae--9a1fe5--container",
  "DD": "x43aef4ae--9a1fe5--title",
  "Sl": "x43aef4ae--9a1fe5--image",
};

module.exports = exports;
